import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { Modal } from '../../../../components/Modal';
import { OutgoingOrderModal } from '../../components/AddToOrderModals/OutgoingOrder/OutgoingOrderModal';
import { setNewOrderValue } from '../../actions';
import { selectNewOrder, selectVehicle } from '../../selectors';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER } from '../../constants';

const STATE = {
  isShowModal: true,
};

const Container = styled.div`
  font-size: 14px;
`;

/* eslint-disable react/prefer-stateless-function */
class OutgoingModalWrapperComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    const clientModalProps = [
      'client',
      'email_contact',
      'financial_contact',
      'includeEmailContact',
      'includeFinancialContact',
      'includeManual',
      'outgoingCompanyId',
      'send_to_email',
      'isBrutoScenario',
    ];
    Object.keys(this.props.values)?.map(key => {
      if (!clientModalProps.includes(key)) {
        this.props.setValue('', key);
      }
    });
    return this.props.reset(this.props.vehicleId);
  }

  save() {
    return this.props.reset();
  }

  render() {
    if (this.props.work)
      return (
        <Modal>
          <Loader />
        </Modal>
      );

    if (!this.state.isShowModal) return null;
    return (
      <Container>
        <OutgoingOrderModal
          bulkAction
          reset={this.reset.bind(this)}
          vehicle={this.props.vehicle}
          onClose={this.reset.bind(this)}
        />
      </Container>
    );
  }
}

OutgoingModalWrapperComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE, REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER]),
    vehicle: selectVehicle(ownProps.vehicleId),
    values: selectNewOrder(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewOrderValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingModalWrapper = compose(withConnect, withRouter, injectIntl)(OutgoingModalWrapperComp);
